// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.solution-page {
  padding-bottom: 0;
}

.solution-hero {
  position: relative;
  min-height: min(78svh, 720px);
  display: grid;
  align-items: end;
  overflow: hidden;
  color: #fff;
}

.solution-hero__media {
  position: absolute;
  inset: 0;
}

.solution-hero__media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.solution-hero__shade {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(180deg, rgba(8, 24, 18, 0.5) 0%, rgba(8, 24, 18, 0.3) 40%, rgba(8, 24, 18, 0.82) 100%),
    linear-gradient(90deg, rgba(8, 24, 18, 0.55) 0%, transparent 60%);
}

.solution-hero__content {
  position: relative;
  z-index: 1;
  width: var(--wide);
  margin: 0 auto;
  padding: 7.5rem 0 3.5rem;
}

.solution-hero__back {
  display: inline-block;
  margin-bottom: 1.25rem;
  font-size: 0.92rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.78);
}

.solution-hero__back:hover {
  color: #fff;
}

.solution-hero__industry {
  font-family: var(--font-display);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--lime);
}

.solution-hero__title {
  max-width: 16ch;
  margin-top: 0.75rem;
  font-family: var(--font-display);
  font-size: clamp(1.9rem, 4.5vw, 3.1rem);
  font-weight: 600;
  line-height: 1.1;
  letter-spacing: -0.03em;
}

.solution-hero__text {
  max-width: 46ch;
  margin-top: 1rem;
  color: rgba(255, 255, 255, 0.86);
  font-size: 1.05rem;
}

.solution-hero__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1.6rem;
}

.solution-page__content {
  padding-top: clamp(3.5rem, 7vw, 5rem);
  padding-bottom: clamp(2rem, 4vw, 3rem);
  display: grid;
  gap: clamp(2.5rem, 5vw, 3.5rem);
}

.solution-block__title,
.solution-partner__title {
  margin-top: 0.35rem;
  font-family: var(--font-display);
  font-size: clamp(1.45rem, 3vw, 2rem);
  font-weight: 600;
  letter-spacing: -0.03em;
  color: var(--ink);
}

.solution-block__list {
  margin: 1.25rem 0 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 0.75rem;
  max-width: 52ch;
}

.solution-block__list li {
  position: relative;
  padding-left: 1.2rem;
  color: var(--text);
  font-weight: 500;
}

.solution-block__list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.7em;
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 50%;
  background: var(--lime-deep);
  transform: translateY(-50%);
}

.solution-partner {
  padding: clamp(1.5rem, 3vw, 2rem);
  border: 1px solid var(--line);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.65);
}

.solution-partner__row {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: clamp(1.25rem, 3vw, 2rem);
  align-items: center;
  margin-top: 0.85rem;
}

.solution-partner__logo {
  display: grid;
  place-items: center;
  width: clamp(140px, 22vw, 180px);
  min-height: 88px;
  padding: 1rem 1.1rem;
  border: 1px solid var(--line);
  border-radius: 6px;
  background: #fff;
}

.solution-partner__logo img {
  width: 100%;
  height: auto;
  max-height: 64px;
  object-fit: contain;
}

.solution-partner__text {
  margin: 0.55rem 0 1.15rem;
  color: var(--muted);
}

@media (max-width: 640px) {
  .solution-partner__row {
    grid-template-columns: 1fr;
  }

  .solution-partner__logo {
    width: 100%;
  }
}

@media (max-width: 640px) {
  .solution-hero__actions {
    flex-direction: column;
    align-items: stretch;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SolutionPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;qEAEmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,aAAa;EACb,+BAA+B;AACjC;;AAEA;;EAEE,mBAAmB;EACnB,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF","sourcesContent":[".solution-page {\r\n  padding-bottom: 0;\r\n}\r\n\r\n.solution-hero {\r\n  position: relative;\r\n  min-height: min(78svh, 720px);\r\n  display: grid;\r\n  align-items: end;\r\n  overflow: hidden;\r\n  color: #fff;\r\n}\r\n\r\n.solution-hero__media {\r\n  position: absolute;\r\n  inset: 0;\r\n}\r\n\r\n.solution-hero__media img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.solution-hero__shade {\r\n  position: absolute;\r\n  inset: 0;\r\n  background:\r\n    linear-gradient(180deg, rgba(8, 24, 18, 0.5) 0%, rgba(8, 24, 18, 0.3) 40%, rgba(8, 24, 18, 0.82) 100%),\r\n    linear-gradient(90deg, rgba(8, 24, 18, 0.55) 0%, transparent 60%);\r\n}\r\n\r\n.solution-hero__content {\r\n  position: relative;\r\n  z-index: 1;\r\n  width: var(--wide);\r\n  margin: 0 auto;\r\n  padding: 7.5rem 0 3.5rem;\r\n}\r\n\r\n.solution-hero__back {\r\n  display: inline-block;\r\n  margin-bottom: 1.25rem;\r\n  font-size: 0.92rem;\r\n  font-weight: 500;\r\n  color: rgba(255, 255, 255, 0.78);\r\n}\r\n\r\n.solution-hero__back:hover {\r\n  color: #fff;\r\n}\r\n\r\n.solution-hero__industry {\r\n  font-family: var(--font-display);\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  letter-spacing: 0.14em;\r\n  text-transform: uppercase;\r\n  color: var(--lime);\r\n}\r\n\r\n.solution-hero__title {\r\n  max-width: 16ch;\r\n  margin-top: 0.75rem;\r\n  font-family: var(--font-display);\r\n  font-size: clamp(1.9rem, 4.5vw, 3.1rem);\r\n  font-weight: 600;\r\n  line-height: 1.1;\r\n  letter-spacing: -0.03em;\r\n}\r\n\r\n.solution-hero__text {\r\n  max-width: 46ch;\r\n  margin-top: 1rem;\r\n  color: rgba(255, 255, 255, 0.86);\r\n  font-size: 1.05rem;\r\n}\r\n\r\n.solution-hero__actions {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem;\r\n  margin-top: 1.6rem;\r\n}\r\n\r\n.solution-page__content {\r\n  padding-top: clamp(3.5rem, 7vw, 5rem);\r\n  padding-bottom: clamp(2rem, 4vw, 3rem);\r\n  display: grid;\r\n  gap: clamp(2.5rem, 5vw, 3.5rem);\r\n}\r\n\r\n.solution-block__title,\r\n.solution-partner__title {\r\n  margin-top: 0.35rem;\r\n  font-family: var(--font-display);\r\n  font-size: clamp(1.45rem, 3vw, 2rem);\r\n  font-weight: 600;\r\n  letter-spacing: -0.03em;\r\n  color: var(--ink);\r\n}\r\n\r\n.solution-block__list {\r\n  margin: 1.25rem 0 0;\r\n  padding: 0;\r\n  list-style: none;\r\n  display: grid;\r\n  gap: 0.75rem;\r\n  max-width: 52ch;\r\n}\r\n\r\n.solution-block__list li {\r\n  position: relative;\r\n  padding-left: 1.2rem;\r\n  color: var(--text);\r\n  font-weight: 500;\r\n}\r\n\r\n.solution-block__list li::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0.7em;\r\n  width: 0.45rem;\r\n  height: 0.45rem;\r\n  border-radius: 50%;\r\n  background: var(--lime-deep);\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.solution-partner {\r\n  padding: clamp(1.5rem, 3vw, 2rem);\r\n  border: 1px solid var(--line);\r\n  border-radius: 6px;\r\n  background: rgba(255, 255, 255, 0.65);\r\n}\r\n\r\n.solution-partner__row {\r\n  display: grid;\r\n  grid-template-columns: auto 1fr;\r\n  gap: clamp(1.25rem, 3vw, 2rem);\r\n  align-items: center;\r\n  margin-top: 0.85rem;\r\n}\r\n\r\n.solution-partner__logo {\r\n  display: grid;\r\n  place-items: center;\r\n  width: clamp(140px, 22vw, 180px);\r\n  min-height: 88px;\r\n  padding: 1rem 1.1rem;\r\n  border: 1px solid var(--line);\r\n  border-radius: 6px;\r\n  background: #fff;\r\n}\r\n\r\n.solution-partner__logo img {\r\n  width: 100%;\r\n  height: auto;\r\n  max-height: 64px;\r\n  object-fit: contain;\r\n}\r\n\r\n.solution-partner__text {\r\n  margin: 0.55rem 0 1.15rem;\r\n  color: var(--muted);\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .solution-partner__row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .solution-partner__logo {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .solution-hero__actions {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
